import PropTypes from 'prop-types';
// main.js
import React from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import UI from 'UI';

export default class WidgetHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object
    };

    renderDefault() {
        return (
            <h3 className={cx('wdp-widget-header', this.props.className)}>
                {this.props.title || '\u00a0'}
            </h3>
        );
    }

    renderTV2NO() {
        let { client, userContext } = this.context.info;

        return (
            <div
                className={cx('wdp-widget-header', 'wdp-header__tv2no', this.props.className, {
                    'wdp-header__tv2no__with_logo': userContext.teamId
                })}
            >
                {userContext.teamId && <div className={`wdp-header__tv2no__team-stripe team-${userContext.teamId}__bg-color`} />}
                {userContext.teamId && <UI.TeamLogo className="wdp-header__tv2no__team-logo" teamId={userContext.teamId} />}

                <h3>{this.props.title || '\u00a0'}</h3>
            </div>
        );
    }

    render() {
        let { client } = this.context.info;
        switch (client) {
            case 'tv2no':
                return this.renderTV2NO();
            default:
                return this.renderDefault();
        }
    }
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/WidgetHeader.js
 **/